module.exports = __webpack_public_path__ + "static/media/em-110.74ce5da1.png";